import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import Box from "../../../../../ui/Box";
import SquareButton from "../../../../../ui/SquareButton";
import Button from "../../../../../ui/Button";
import ActionsMenu from "../../../../../ui/ActionsMenu";

const useStyles = makeStyles(() => ({
  topBar: {
    display: "flex",
    justifyContent: "space-between"
  },
  topBarLeft: {
    display: "flex",
    "& > button": {
      marginRight: 12
    }
  },
  topBarRight: {
    display: "flex",
    "& > div": {
      marginLeft: 12
    }
  }
}));

const TopBar = ({
  reload,
  returnBack,
  openDeleteModal,
  openAcceptModal,
  openDeclineModal,
  isAcceptingRequest,
  isDecliningRequest,
  reloadRequest,
  sendToWork,
  isSendingToWork,
  openArchiveModal,
  isArchivingRequest,
  statusId,
  disabled,
  disabledApprove}) => {
  const classes = useStyles();

  const actions = [
    {
      label: "Удалить заявку",
      onClick: openDeleteModal
    }
  ];

  return (
    <Box>
      <div className={classes.topBar}>
        <div className={classes.topBarLeft}>
          <SquareButton onClick={returnBack}>
            <ChevronLeftIcon fontSize="small" />
          </SquareButton>
          <SquareButton onClick={reload}>
            <CachedIcon fontSize="small" />
          </SquareButton>
        </div>
        <div className={classes.topBarRight}>
          {statusId != 3 && <>
            <Button
              onClick={openArchiveModal}
              loading={isArchivingRequest}
              disabled={disabled}>
              В АРХИВ
            </Button>
            <div></div></>}

          { statusId == 0 ?
          <Button
            onClick={sendToWork}
            loading={isSendingToWork}
            disabled={disabled}>
            ПРИНЯТЬ В РАБОТУ
          </Button> : (
              statusId == 1 ? <>
                <Button
                  onClick={openAcceptModal}
                  loading={isAcceptingRequest}
                  disabled={disabledApprove}
                  color="green">
                  ПОДТВЕРДИТЬ
                </Button>
                <div></div>
                <Button
                  onClick={openDeclineModal}
                  loading={isDecliningRequest}
                  disabled={disabled}
                  color="pink">
                  ОТКЛОНИТЬ
                </Button></>
                :(statusId == -1 &&
                  <Button
                    onClick={sendToWork}
                    loading={isSendingToWork}
                    disabled={disabled}>
                    ВОЗОБНОВИТЬ
                  </Button>
                )
            )
          }
          <ActionsMenu actions={actions} />
        </div>
      </div>
    </Box>
  );
};

export default withRouter(TopBar);
